// src/disc/report/discAlgi.js
//
// KARŞILIKLI ALGI — aynı davranış, karşıdakinin sinyaline göre farklı okunur.
//
// KAYNAK: ~/SOMERENLABS_ORG/disc_iletisim/kaynak/en_disc_profilleri/en15.jpg ve en16.jpg
// ("IF YOU ARE A 'D' YOU ARE SEEN BY THE…"). Kaynak yalnız SIFAT LİSTESİ verir ve
// listenin tamamı olumsuzdur: "arrogant, gullible, manipulative, indecisive…".
//
// SOMEREN KURALI (bkz. disc_iletisim/*_cevirim.md): kimseye sıfat yakıştırılmaz.
// Kaynaktan alınan şey YAPIdır — "aynı davranış farklı sinyallere farklı iniyor" —
// yargı değil. Her hücrede iki alan var:
//   okunus : davranışın karşı tarafta nasıl OKUNABİLECEĞİ (kişi hakkında değil,
//            algı hakkında bir cümle; "…olarak okunabilir")
//   kopru  : o okumayı düzeltmek için atılacak SOMUT adım
//
// Köşegen (D-D, I-I, S-S, C-C) kaynakta "olumlu" yazılmıştır; biz orada da
// gerçek riski adlandırıyoruz: benzerlik hızlı anlaşma getirir ama aynı kör
// noktayı iki katına çıkarır.

export const ALGI = {
  tr: {
    D: {
      D: { okunus: "Aynı hız, aynı doğrudanlık: birbirinizi çabuk anlarsınız. Ama iki taraf da yönü kurmak isteyince görüşme bir güç denemesine dönebilir.",
           kopru: "Hangi kararda kimin son sözü olduğunu baştan söyleyin." },
      I: { okunus: "Fazla “şimdi ve burada”; fikri konuşmaya sabrı yok gibi okunabilir.",
           kopru: "Karara geçmeden önce fikre bir tur alan bırakın." },
      S: { okunus: "Aceleci ve tek başına karar veriyor gibi okunabilir; güven kurulmadan hız artınca karşı taraf geri çekilir.",
           kopru: "Önce kararın gerekçesini ve ekibe etkisini söyleyin, sonra hızlanın." },
      C: { okunus: "Hazırlıksız ve yüzeysel okunabilir; veri tamamlanmadan kapanış istemek direnç üretir.",
           kopru: "Kararın hangi veriye dayandığını yazılı bırakın." },
    },
    I: {
      D: { okunus: "Somut çıktıya bağlanmayan konuşma ve fazla iyimserlik olarak okunabilir.",
           kopru: "Enerjiyi bir taahhüde ve tarihe bağlayın." },
      I: { okunus: "Aynı tempo, karşılıklı besleme: ortam canlanır. Ama kimse kaydı tutmazsa konuşulan karar buharlaşır.",
           kopru: "Konuşulanı birinin yazmasını baştan kararlaştırın." },
      S: { okunus: "Fazla hızlı ve yüzeysel temas olarak okunabilir; ilişki derinleşmeden geçiliyor hissi doğar.",
           kopru: "Tempoyu düşürün, tek kişiye ayırdığınız süreyi uzatın." },
      C: { okunus: "Kanıtsız iyimserlik ve detayın atlanması olarak okunabilir.",
           kopru: "İddiayı bir rakamla ya da somut örnekle destekleyin." },
    },
    S: {
      D: { okunus: "Yavaş ve net tavır almıyor olarak okunabilir; sessizlik onay sanılır.",
           kopru: "İtirazınızı erken ve açık söyleyin." },
      I: { okunus: "Mesafeli ve isteksiz okunabilir; heyecana katılmayınca karşı taraf reddedilmiş hisseder.",
           kopru: "Neye evet dediğinizi sesli söyleyin." },
      S: { okunus: "Aynı sakinlik, aynı özen: güven hızlı kurulur. Ama iki taraf da zor konuyu açmayınca sorun sessizce büyür.",
           kopru: "Zor konuyu kimin gündeme taşıyacağını önceden kararlaştırın." },
      C: { okunus: "Ölçütü kişiselleştiren, duyguya fazla yer veren bir tutum olarak okunabilir.",
           kopru: "Tercihinizi hangi ölçüte dayandırdığınızı birlikte söyleyin." },
    },
    C: {
      D: { okunus: "Kararsız ve yavaş okunabilir; soru sormak engel çıkarmak sanılır.",
           kopru: "Sorularınızı tek seferde ve ne zaman yanıt beklediğinizi belirterek sorun." },
      I: { okunus: "Fazla ciddi ve detayda boğulan olarak okunabilir; enerjiyi düşürdüğü hissedilir.",
           kopru: "Önce niyeti onaylayın, düzeltmeyi ondan sonra getirin." },
      S: { okunus: "Soğuk ve mesafeli okunabilir; veri öne çıkınca insan geri planda kalmış hissi doğar.",
           kopru: "Kararın insana etkisini de sesli değerlendirin." },
      C: { okunus: "Aynı titizlik, aynı standart: kalite yükselir. Ama iki taraf da kusursuzluk arayınca karar gecikir.",
           kopru: "“Yeterince iyi”nin tanımını en baştan yazın." },
    },
  },

  en: {
    D: {
      D: { okunus: "Same pace, same directness — you understand each other quickly. But when both sides want to set the direction, the conversation can turn into a contest.",
           kopru: "Say at the start who has the final word on which decision." },
      I: { okunus: "Can read as too “here and now”, with no patience for talking an idea through.",
           kopru: "Leave one round of open discussion before moving to the decision." },
      S: { okunus: "Can read as rushed and unilateral; when pace rises before trust is built, the other side withdraws.",
           kopru: "Give the reasoning and the effect on the team first, then speed up." },
      C: { okunus: "Can read as unprepared and superficial; asking to close before the data is complete creates resistance.",
           kopru: "Put in writing which evidence the decision rests on." },
    },
    I: {
      D: { okunus: "Can read as talk that never lands on a concrete outcome, and as over-optimism.",
           kopru: "Tie the energy to one commitment and one date." },
      I: { okunus: "Same tempo, mutual momentum — the room comes alive. But if nobody records it, the decision evaporates.",
           kopru: "Agree up front who writes down what was decided." },
      S: { okunus: "Can read as contact that moves too fast and stays on the surface, as if the relationship is skipped.",
           kopru: "Slow the tempo and give each person longer." },
      C: { okunus: "Can read as optimism without evidence and detail being skipped.",
           kopru: "Back the claim with a number or a concrete example." },
    },
    S: {
      D: { okunus: "Can read as slow and non-committal; silence is taken for agreement.",
           kopru: "Say your objection early and plainly." },
      I: { okunus: "Can read as distant or reluctant; not joining the enthusiasm feels like rejection.",
           kopru: "Say out loud what you are saying yes to." },
      S: { okunus: "Same calm, same care — trust builds fast. But when neither side opens the hard topic, the problem grows quietly.",
           kopru: "Decide in advance who will put the hard topic on the table." },
      C: { okunus: "Can read as making the criterion personal and giving feelings too much room.",
           kopru: "State the criterion your preference rests on alongside the preference." },
    },
    C: {
      D: { okunus: "Can read as indecisive and slow; asking questions is taken for obstruction.",
           kopru: "Ask your questions in one pass and say when you need the answer." },
      I: { okunus: "Can read as too serious and lost in detail, as if draining the energy.",
           kopru: "Acknowledge the intention first, bring the correction after." },
      S: { okunus: "Can read as cold and distant; when data leads, people feel moved to the background.",
           kopru: "Assess the human effect of the decision out loud as well." },
      C: { okunus: "Same rigour, same standard — quality rises. But when both sides seek perfection, the decision is late.",
           kopru: "Write the definition of “good enough” at the very start." },
    },
  },
};

// Raporda gösterilecek okumaları üretir: kişinin ANA sinyali, dört sinyale nasıl iner?
export function algiOkumalari(anaHarf, lang = "tr") {
  const dil = lang === "en" ? "en" : "tr";
  const satir = ALGI[dil][anaHarf];
  if (!satir) return [];
  return ["D", "I", "S", "C"].map((karsi) => ({
    karsi,
    kendi: karsi === anaHarf,
    okunus: satir[karsi].okunus,
    kopru: satir[karsi].kopru,
  }));
}
